import React from "react";
import { Routes, Route } from "react-router-dom";
import Contact from "./page/Contact";
import Home from "./page/Home";
import HajjPackages from "./page/HajjPackages";
import NotFound from "./page/NotFound";
import Header from "./layout/Header";
import CtaArea from "./layout/CtaArea";
import Footer from "./layout/Footer";
import CopyRight from "./layout/CopyRight";
import ScrollAirplaneAnimation from "./layout/ScrollAirplaneAnimation";
import About from "./page/About";
import CorporateTravel from "./page/CorporateTravel";
import TestEmail from "./page/test-email";
import ContactForm from "./page/ContactForm";
import TravelConsulting from "./page/TravelConsulting";
import ReligiousTravel from "./page/ReligiousTravel";
import Visa from "./page/Visa";
import FaqsArea from "./page/Faqs";
import Faqs from "./page/faq";
import Media from "./page/Media";
import HajjMedia from "./page/HajjMedia";
import MediaVideos from "./page/MediaVideo";
import UmrahPackages from "./page/UmrahPackages";
import HajjVideos from "./page/HajjVideos";
import Testimonials from "./page/Testimonials";
import PrivacyPolicy from "./page/PrivacyPolicy";
import Packages1 from "./page/Hajj2025/Package1";
import Packages2 from "./page/Hajj2025/Package2";
import Packages3 from "./page/Hajj2025/Package3";
import Packages4 from "./page/Hajj2025/Package4";
import Packages5 from "./page/Hajj2025/Package5";
import Packages6 from "./page/Hajj2025/Package6";
import Packages7 from "./page/Hajj2025/Package7";
import Packages8 from "./page/Hajj2025/Package8";
import InstantInquiry from "./page/InstantInquiry";
import Package1B from "./page/Hajj2025MaktabB/Package1";
import Package2B from "./page/Hajj2025MaktabB/Package2";
import Package3B from "./page/Hajj2025MaktabB/Package3";
import Package4B from "./page/Hajj2025MaktabB/Package4";
import Package5B from "./page/Hajj2025MaktabB/Package5";
import Package1 from "./page/Umrah2025/Package1";
import Package2 from "./page/Umrah2025/Package2";

import Package3 from "./page/Umrah2025/Package3";


const App = () => (
  <>
    <Header />
    <ScrollAirplaneAnimation />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/hajj-packages" element={<HajjPackages />} />
      <Route path="/hajj/package-1" element={<Packages1 />} />
      <Route path="/hajj/package-2" element={<Packages2 />} />
      <Route path="/hajj/package-3" element={<Packages3 />} />
      <Route path="/hajj/package-4" element={<Packages4 />} />
      <Route path="/hajj/package-5" element={<Packages5 />} />
      <Route path="/hajj/package-6" element={<Packages6 />} />
      <Route path="/hajj/package-7" element={<Packages7 />} />
      <Route path="/hajj/package-8" element={<Packages8 />} />
      <Route path="/hajj/package1B" element={<Package1B />} />
      <Route path="/hajj/package2B" element={<Package2B />} />
      <Route path="/hajj/package3B" element={<Package3B />} />
      <Route path="/hajj/package4B" element={<Package4B />} />

      <Route path="/hajj/package5B" element={<Package5B />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/corporate-travel" element={<CorporateTravel />} />
      <Route path="/travel-consulting" element={<TravelConsulting />} />
      <Route path="/religous-travel" element={<ReligiousTravel />} />
      <Route path="/visa" element={<Visa />} />
      <Route path="/faq" element={<Faqs />} />
      <Route path="/media" element={<Media />} />
      <Route path="/hajj-media" element={<HajjMedia />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/videos" element={<MediaVideos />} />
      <Route path="/hajj-videos" element={<HajjVideos />} />
      <Route path="/umrah-packages" element={<UmrahPackages />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/test-email" element={<TestEmail />} />
      <Route path="/contact" element={<ContactForm />} />
      <Route path="/InstantInquiry" element={<InstantInquiry />} />
      <Route path="/package1" element={<Package1 />} />

      <Route path="/package2" element={<Package2 />} />

      <Route path="/package3" element={<Package3 />} />


      <Route path="*" element={<NotFound />} />
    </Routes>
    <CtaArea />
    <Footer />
    <CopyRight />
  </>
);

export default App;
